import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { Inertia } from '@inertiajs/inertia';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import UserLayout from '../../Shared/UserLayout';
import DataContainer from '../../Shared/DataContainer';
import DropdownButton from '../../Shared/DropdownButton';
import Pagination from '../../Shared/Pagination';
import Icon from '../../Shared/Icon';
import { can } from '../../utils';

const Purchased = () => {
     const { auth, errors, data } = usePage().props;
     console.log(data);
     const [values, setValues] = useState({});

     return (
          <React.Fragment key="security-index">
               <Helmet>
                    <title>Purchase History</title>
               </Helmet>
               <div className="p-2 mx-auto max-w-7xl">
                    <InertiaLink className="font-semibold leading-tight text-gray-700 text-md hover:text-gray-800" href={route('home')}>Dashboard</InertiaLink> | <span className="leading-tight text-gray-700 text-md">Purchase History</span>
               </div>
               {!data && (<div className="col-span-12 px-4 py-4 text-center text-blue-600 bg-blue-100 border border-blue-500 rounded">No Item has been purchased yet. Please head to the <InertiaLink className="font-bold" href={route('catalog.index')}>catalog</InertiaLink> to start purchasing.</div>)}
               {data && (<DataContainer>
                    <table className="col-span-12 text-sm table-fixed">
                         <thead className="bg-gray-400">
                              <tr>
                                   <th className="px-4 py-2">Receipt No.</th>
                                   <th className="px-4 py-2">Buyer</th>
                                   <th className="px-4 py-2">Total</th>
                                   <th className="px-4 py-2">Paid Via</th>
                                   <th className="px-4 py-2">Reference No.</th>
                                   <th className="px-4 py-2">Date</th>
                                   <th className="px-4 py-2"></th>
                              </tr>
                         </thead>
                         <tbody>
                              {data.data.map(({id, number, user, origin, reference, created, total, currency, qtyItems}) => {
                                   return <tr key={id}>
                                        <td className="px-4 py-2 text-center border">{number}</td>
                                        <td className="px-4 py-2 text-center border">{user}</td>
                                        <td className="px-4 py-2 text-right border">{currency} {total.toFixed(2)}</td>
                                        <td className="px-4 py-2 text-center border">{origin}</td>
                                        <td className="px-4 py-2 text-center border">{reference}</td>
                                        <td className="px-4 py-2 text-center border">{created}</td>
                                        <td className="px-4 py-2 text-center border">
                                             <DropdownButton caption="Actions" color="blue">
                                                  <InertiaLink href={route('order.show', id)} className="flex block px-6 py-2 text-gray-600 hover:bg-gray-100 hover:text-gray-700">
                                                       <Icon name={'eye'} className={'fill-current w-5 h-5 mr-2'} /> View Details
                                                  </InertiaLink>
                                                  <a href={route('order.pdf', id)} className="flex block px-6 py-2 text-gray-600 hover:bg-gray-100 hover:text-gray-700">
                                                       <Icon name={'printer'} className={'fill-current w-5 h-5 mr-2'} /> Print Receipt Josny
                                                  </a>
                                             </DropdownButton>
                                        </td>
                                   </tr>
                              })}
                         </tbody>
                    </table>
               </DataContainer>)}
          </React.Fragment>
     );
};

// Persisten layout
// Docs: https://inertiajs.com/pages#persistent-layouts
Purchased.layout = page => <UserLayout children={page} header={'Orders & Items'} />;

export default Purchased;
